<template>
    <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon icon-style">
                <md-icon>inventory</md-icon>
                Services
            </div>
        </md-card-header>
        <md-card-content>
            <p v-if="!services || services.length === 0" class="grayedout-text text-center">
                No services found
            </p>
            <div v-else>
                <div class="service-table-container" :class="{ 'with-scroll': enableScroll }">
                    <md-table class="context-menu-support custom-paginated-table">
                        <md-table-row>
                            <md-table-head>Service Code</md-table-head>
                            <md-table-head>Service</md-table-head>
                            <md-table-head>Description</md-table-head>
                            <md-table-head>Quantity</md-table-head>
                            <md-table-head>Actions</md-table-head>
                        </md-table-row>
                        <md-table-row v-for="service in services" :key="service.serviceId">
                            <md-table-cell>{{ service.serviceCode }}</md-table-cell>
                            <md-table-cell>{{ service.name }}</md-table-cell>
                            <md-table-cell>{{ service.description }}</md-table-cell>
                            <md-table-cell class="quantity-column">
                                {{ service.quantity }}
                                <span class="quantity-type">{{ service.quantityType }}</span>
                            </md-table-cell>
                            <md-table-cell v-if="$root.isDesktop && !isReadOnlyUser" class="actions-column">
                                <div class="action-button">
                                    <md-button
                                        v-if="!isReadOnlyUser"
                                        title="Delete service"
                                        class="md-danger md-just-icon md-round"
                                        :disabled="isInvoiced"
                                        @click.stop="handleDeleteService(service.serviceId)"
                                    >
                                        <md-icon>delete</md-icon>
                                    </md-button>
                                    <md-tooltip v-if="isInvoiced" class="line-tooltip" md-direction="top">
                                        You cannot delete a service when the trip is invoiced.
                                    </md-tooltip>
                                </div>
                            </md-table-cell>
                        </md-table-row>
                    </md-table>
                </div>
            </div>
        </md-card-content>
        <md-card-actions v-if="($root.isDesktop && !isReadOnlyUser) || isInvoiced">
            <md-button class="md-success" @click="handleAddService()">
                Add Service
            </md-button>
        </md-card-actions>
    </md-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { GeneralMixin } from '@/mixins';
import { handleRequests, showErrorMessage } from '@/helpers';
import TripServiceLineModal from '../Modals/TripServiceLineModal';

export default {
    name: 'Tripservices',
    mixins: [GeneralMixin],
    components: {},
    props: {
        services: {
            type: Array,
            default: () => []
        },
        isInvoiced: {
            type: Boolean,
            default: false
        },
        tripId: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            loadCapacityList: []
        };
    },
    computed: {
        ...mapGetters({
            user: 'user/user',
            isReadOnlyUser: 'user/isReadOnlyUser',
            isSupportStaff: 'user/isSupportStaff'
        }),
        loadTotals() {
            return this.$_getLoadTotals(this.services, ['volume', 'weight']);
        },
        enableScroll() {
            return this.services.length > 5;
        }
    },
    methods: {
        handleUpdateservice() {
            this.$emit('serviceUpdated');
        },
        handleAddService() {
            this.$modal
                .show(TripServiceLineModal, {
                    stopId: this.stopId,
                    lines: this.lines
                })
                .then((response) => {
                    this.$emit('serviceUpdated');
                    this.$modal.hide();
                });
        },
        async handleConfirmDelete(serviceId) {
            this.$_handleLoaderState(true, 'UPDATING...');
            if (this.tripId === null || this.tripId === undefined) {
                const message = 'Trip does not exists.';
                showErrorMessage(this, message);
                this.$_handleLoaderState(false);
                return;
            }

            try {
                const payload = {
                    method: 'delete'
                };
                const api = `/api/trips/${this.tripId}/lines/${serviceId}`;

                await handleRequests(api, payload);

                this.$emit('serviceUpdated');

                this.$notify({
                    message: `Service deleted!`,
                    type: 'success'
                });
            } catch (e) {
                const message = 'Cannot delete service.';
                showErrorMessage(this, message);
            } finally {
                this.$_handleLoaderState(false);
            }
        },
        async handleDeleteService(serviceId) {
            this.$messageBox
                .show({
                    class: 'sm-modal-container',
                    title: 'Delete Service',
                    body: 'Are you sure you want to delete this service?',
                    buttons: ['Confirm', 'Cancel']
                })
                .then(async (response) => {
                    if (response.toLowerCase() === 'confirm') 
                        await this.handleConfirmDelete(serviceId);
                });
        }
    },
    mounted() {
        this.loadCapacityList = [];
        if (this.user.vehicleCapacityUnitsConfiguration && this.user.vehicleCapacityUnitsConfiguration.length > 0) {
            this.loadCapacityList = this.user.vehicleCapacityUnitsConfiguration.filter((x) => x.type !== 'quantity');
        }
    }
};
</script>

<style lang="scss" scoped>
.service-table-container {
    max-height: 600px;
}

.service-table-container.with-scroll {
    overflow-y: scroll;
}

.service-totals-container.with-scroll {
    padding-right: 15px;
}

.custom-badge.inventory-status {
    max-width: 100%;
}

.service-count-column {
    text-align: right;
    padding-right: 50px;
}

.volume-column {
    width: 60px;
}

.width-column {
    width: 60px;
}

.actions-column {
    width: 100px;
}

.icon-style {
    color: white;
}
</style>
